import { useEffect, useRef } from 'react'

import Play from './src/Play'
// import Traits from './src/Traits'
import { homeAnimation } from "./Animations"
import {useSelector,useDispatch} from "react-redux"
import { setReel, setPlayaudio } from '../../../../redux/mainPageSlice'
import lottie from 'lottie-web';

import "./home.scss"

export default function Home() {
    const ref = useRef(null)
    const sound = useRef(null)
    const percentage = useSelector((state) => state.mainPageSliceReducer.percentage)
    const dispatch = useDispatch()
    const handleReel=()=>{
        dispatch(setReel(true))
    }
    useEffect(() => {
        let tl=null
        if(percentage===100){
            setTimeout(() => {
                tl=homeAnimation()
            }, 2000);
        }
        return () => tl?.scrollTrigger?.kill()
    }, [percentage])

    const animationContainer = useRef()
    useEffect(() => {
        const anim = lottie.loadAnimation({
            container: animationContainer.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: "https://res.cloudinary.com/reeelecs/raw/upload/v1654759892/mudakikwa.com/lf30_editor_xjn26o3a_vfenzv.json",
        });
        return () => anim.destroy(); // optional clean up for unmounting
    }, [animationContainer]);

    return (
        <div ref={ref} id="home-page">
            <div></div>
            <div className="homepage">
                <div className="cta">
                    <div className="small-overflow" id="home-text">
                        <div className="small-text opacity">Hello There My name is  Mudakikwa Julio Fred  and I am an</div>
                    </div>
                    <div className="big-text-overflow">
                        <div className="big-text opacity">Creative Fullstack</div>
                    </div>
                    <div className="big-text-2">
                        <div className="big-text-overflow-2 "><div className="developer opacity">Developer</div></div>
                        <div className="text-desc opacity">I am a metaverse developer and I am passionate about web experience,
                            I am in zone when developing clean sites which create a memorable experience.
                            When  I am not building immersive experience I am at the gym putting on more weight.
                            Got an interesting thint to tell me  let us connect.</div>
                        <div className="d-flex ctas">
                            <div className="btn-red-overflow opacity">
                                <div className="btn-red">
                                    <div className="btn-red-text" >Let Us Talk</div>
                                </div>
                            </div>
                            <div className="btn-red-overflow-1 opacity">
                                <div className="d-flex" onClick={()=>{
                                    console.log("eleemnt clicked")
                                    handleReel()
                                }}>
                                    <Play />
                                    <div className="play-text">Play Show Reel</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom-elements">
                <div className="drag-info d-flex">
                    <div className="lottie-container">
                        <div className="drag-lottie" ref={animationContainer}></div>
                    </div>
                    <div className="drag-text">Drag To Rotate</div>
                </div>
            </div>
        </div >
    )
}
